import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-white selection:bg-stone-200 selection:text-stone-900" data-id="element-171">
      <HeroSection data-id="element-172" />
      <FeaturesSection data-id="element-173" />
      <BenefitsSection data-id="element-174" />
      <GuaranteeSection data-id="element-175" />
      <CTASection data-id="element-176" />
      <Footer data-id="element-177" />
    </main>;
}